module.exports = __webpack_public_path__ + "img/loading-summary-bg@3x.aa78cae5.png";